import { render, staticRenderFns } from "./AppSubtitle.vue?vue&type=template&id=4cc49f5e&"
import script from "./AppSubtitle.vue?vue&type=script&lang=js&"
export * from "./AppSubtitle.vue?vue&type=script&lang=js&"
import style0 from "./AppSubtitle.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports